import { client } from './ApolloDefaultClient';
import { ApolloClient } from 'apollo-client';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';

import axios from 'axios';

class BaseService {
  public client: ApolloClient<NormalizedCacheObject> = client;
  public httpClient: any = axios;
}

export { BaseService };
export default new BaseService();
